import { Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, TooltipShortcut } from "@itk/mui-components";
import { notFoundPageK, useNotFoundPageT } from "src/translation-hooks/not-found-page";

const NotFoundPage = () => {
  const notFoundPageT = useNotFoundPageT();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh"
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
      <Typography variant="h3" gutterBottom>
        404
      </Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {notFoundPageT.oopsPageNotFound}
      </Typography>
      <TooltipShortcut shortcut={{ action: handleNavigate, shortCutKey: "g", modifier: "alt" }}>
        <Button t={notFoundPageT} k={notFoundPageK} field="oopsPageNotFound" variant="contained" color="primary" onClick={handleNavigate} />
      </TooltipShortcut>
    </Container>
  );
};

export default NotFoundPage;
